import { ItemChartModel } from '../global/item-chart.model';

export class InvoicingCutoffChartModel {
  total: number = 0;
  states: ItemChartModel[] = [];
}
